export const sanitizeFileName = (fileName: string): string => {
  const extension = fileName.split(".").pop();
  const nameWithoutExt = fileName.replace(/\.[^/.]+$/, "");

  const sanitized = nameWithoutExt
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-zA-Z0-9-_]/g, "_")
    .replace(/_+/g, "_");

  return `${sanitized}.${extension}`;
};
